export default __webpack_public_path__ + "static/28_Van@2x-f399f9377cedcd82bb144b7c72ddecf6.png";